import React from "react";
import { TriggerBuilder } from "@redriver/cinnamon";
import { Menu } from "semantic-ui-react";
import { invoiceJobItems } from "./actions";

const InvoiceSelectedItems = ({
  as: As = Menu.Item,
  jobId,
  selectedIds,
  onSubmitted,
  ...props
}) => (
  <TriggerBuilder
    submitAction={invoiceJobItems}
    submitParams={{ jobId, selectedIds }}
    onSubmitted={onSubmitted}
    renderTrigger={(fireTrigger) => <As onClick={fireTrigger} {...props} />}
  />
);

export default InvoiceSelectedItems;
